import { render, staticRenderFns } from "./HomeGameWheelInformation.vue?vue&type=template&id=06472953&scoped=true&"
import script from "./HomeGameWheelInformation.vue?vue&type=script&lang=js&"
export * from "./HomeGameWheelInformation.vue?vue&type=script&lang=js&"
import style0 from "./HomeGameWheelInformation.vue?vue&type=style&index=0&id=06472953&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06472953",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06472953')) {
      api.createRecord('06472953', component.options)
    } else {
      api.reload('06472953', component.options)
    }
    module.hot.accept("./HomeGameWheelInformation.vue?vue&type=template&id=06472953&scoped=true&", function () {
      api.rerender('06472953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeGameWheelInformation.vue"
export default component.exports